var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.count)?_c('div',{staticClass:"role"},[_c('div',{staticClass:"role-capacity"},[_c('div',{staticClass:"role-filled",style:({width: _vm.progressWidth})})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }